import DomainModel from './DomainModel'

export default class LodgingExpenses extends DomainModel {
    constructor(
        private _id: string,
        private investigatorId: any,
        private requestCoordinates: Number[],
        private requestAddress: string,
        private requestStatus: string,
        private requestDate: string,
        private requestRejectionReason: string,
        private requestActionTakenBy: any,
        private lodgingAmount: string,
        private lodgingAmountStatus: string,
        private amountActionTakenBy: any,
        private lodgingReceipts: string[],
        private lodgingReceiptsStatus: string,
        private receiptActionTakenBy: any,
        private paymentStatus: string,
        private paymentDate?: string,
        private utrNumber?: string,
    ) {
        super()
    }

    getId = () => this._id

    getInvestigatorId = () => this.investigatorId

    getRequestCoordinates = () => this.requestCoordinates

    getRequestAddress = () => this.requestAddress

    getRequestStatus = () => this.requestStatus

    getRequestDate = () => this.requestDate

    getRequestRejectionReason = () => this.requestRejectionReason

    getRequestActionTakenBy = () => this.requestActionTakenBy

    getLodgingAmount = () => this.lodgingAmount

    getLodgingAmountStatus = () => this.lodgingAmountStatus

    getAmountActionTakenBy = () => this.amountActionTakenBy

    getLodgingReceipts = () => this.lodgingReceipts

    getLodgingReceiptsStatus = () => this.lodgingReceiptsStatus

    getReceiptActionTakenBy = () => this.receiptActionTakenBy

    getPaymentStatus = () => this.paymentStatus

    getPaymentDate = () => this.paymentDate

    getUtrNumber = () => this.utrNumber
}